import { Button, Flex, HStack, InvertTheme, Menu } from '@stoplight/mosaic';
import React, { useContext, useMemo } from 'react';
import { EXAMPLE_SPECS } from '../constants';
import { GlobalContext } from '../context';
export const DemoNavbar = () => {
    return (React.createElement(InvertTheme, null,
        React.createElement(Flex, { h: "3xl", shrink: 0, px: 5, alignItems: "center", bg: "canvas-pure" },
            React.createElement(HStack, { w: "1/2", alignItems: "center", spacing: 4 },
                React.createElement("a", { href: "/" },
                    React.createElement("img", { src: "/logo.svg", alt: "Share Of Model", width: "250px" }))),
            React.createElement(Flex, { w: "1/3", justifyContent: "center" },
                React.createElement(SpecUrlInput, null)),
            React.createElement(HStack, { w: "1/3", flex: 1, justifyContent: "end" },
                React.createElement(Button, { as: "a", appearance: "minimal", target: "__blank", href: "https://shareofmodel.ai" }, "Share Of Model")))));
};
const SpecUrlInput = () => {
    return (React.createElement(HStack, { spacing: 2, flex: 1 },
        React.createElement(ExamplePicker, null)));
};
const ExamplePicker = () => {
    const { apiDescriptionUrl, setDescriptionUrl } = useContext(GlobalContext);
    const menuItems = useMemo(() => {
        const items = [
            {
                type: 'option_group',
                value: apiDescriptionUrl,
                onChange: setDescriptionUrl,
                children: EXAMPLE_SPECS.map(s => ({
                    title: s.text,
                    value: s.value,
                })),
            },
        ];
        return items;
    }, [apiDescriptionUrl, setDescriptionUrl]);
    return (React.createElement(Menu, { closeOnPress: true, "aria-label": "Picker Menu", items: menuItems, renderTrigger: ({ isOpen }) => (React.createElement(Button, { iconRight: ['fas', 'caret-down'], active: isOpen }, "Choose the API")) }));
};
